/** Как `SHIFT_STATE_KEY` в старом Layout — синхронизация с классическим фронтом */
export const SHIFT_STATE_KEY = 'servicedesk_shift_state'

export type ShiftLocalState = {
  active: boolean
  startedAt: string | null
}

export function getShiftLocalState(): ShiftLocalState {
  try {
    const raw = localStorage.getItem(SHIFT_STATE_KEY)
    if (!raw) return { active: false, startedAt: null }
    const parsed = JSON.parse(raw) as { active?: boolean; startedAt?: string | null }
    return {
      active: !!parsed.active,
      startedAt: parsed.startedAt || null,
    }
  } catch {
    return { active: false, startedAt: null }
  }
}

/**
 * @param broadcast — false при оптимистичном обновлении до ответа API: иначе событие вызовет лишний refresh и сбросит UI.
 */
export function setShiftLocalState(state: ShiftLocalState, broadcast = true) {
  try {
    localStorage.setItem(SHIFT_STATE_KEY, JSON.stringify(state))
  } catch {
    /* ignore */
  }
  if (!broadcast) return
  try {
    window.dispatchEvent(new CustomEvent('servicedesk:shift-changed', { detail: state }))
  } catch {
    /* ignore */
  }
}
